import { CSSProperties } from 'react';
import { useQuery } from '@tanstack/react-query';

import { listService } from '@/services/database/lists';
import { useListStore } from '@/stores';
import { ListType } from '@/types';

import { createBaseListColumns } from './listViewColumns/baseColumns';
import { createDataSourceListColumns } from './listViewColumns/dataSourceColumns';
import { createListColumnOptions } from './listViewColumns/listColumnOptions';
import { useAntDesignTheme } from './useAntDesignTheme';
import { useMaps } from './useMaps';

export const useListViewColumns = () => {
    const { token } = useAntDesignTheme();
    const { integrationLabelToIconMap } = useMaps();
    const { selectedList } = useListStore();
    const listType = selectedList?.type as ListType;
    const dataSourceSignature =
        selectedList?.dataSources
            ?.map((dataSource) => String(dataSource.connectedAccount?.id ?? dataSource.id) + ':' + dataSource.updatedAt)
            .sort()
            .join('|') ?? '';

    const { data: providerColumnSchemas = [] } = useQuery({
        enabled: Boolean(selectedList?.id && selectedList?.dataSources?.length),
        queryFn: () => listService.getDataSourceColumnSchemas(selectedList?.id as string),
        queryKey: ['listDataSourceColumnSchemas', selectedList?.id, dataSourceSignature],
        staleTime: 60_000,
    });

    const categoryIconStyle = {
        verticalAlign: '-0.1rem',
        marginRight: '0.2rem',
    } as CSSProperties;

    const sectionIconStyle = {
        display: 'block',
    } as CSSProperties;

    const { peopleListColumns, companyListColumns, financialListColumns } = createBaseListColumns({
        categoryIconStyle,
        sectionIconStyle,
        token,
    });
    const { mergedDataSourceListColumns } = createDataSourceListColumns({
        categoryIconStyle,
        integrationLabelToIconMap,
        providerColumnSchemas,
        selectedList,
        token,
    });

    return createListColumnOptions({
        companyListColumns,
        financialListColumns,
        listType,
        mergedDataSourceListColumns,
        peopleListColumns,
        sectionIconStyle,
    });
};
